import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ArrowMixedIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 11H2C1.45 11 1 11.45 1 12C1 12.55 1.45 13 2 13H22C22.55 13 23 12.55 23 12C23 11.45 22.55 11 22 11Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ArrowMixedIcon.displayName = 'ArrowMixedIcon';
